{
  "automation": {
    "title": "Exploit interdit",
    "body": "ANIDEX a détecté un bot, un agent IA (ChatGPT, Atlas, Comet…), un navigateur automatisé ou un auto-clicker. Automatiser l’ouverture des boosters ou toute autre action du jeu est strictement interdit.",
    "howTo": "Pour jouer, ouvre ANIDEX normalement dans ton navigateur ou depuis l’application installée (PWA), et joue toi-même.",
    "warning": "Toute tentative d’exploit peut entraîner la suppression des gains obtenus et le bannissement du compte.",
    "code": "Code : {{reason}}",
    "reload": "Recharger"
  },
  "language": {
    "label": "Langue",
    "french": "Français",
    "english": "English"
  },
  "player": {
    "profile": "Voir le profil de {{username}}"
  },
  "nav": {
    "home": "Accueil",
    "homeAria": "Accueil ANIDEX",
    "collection": "Collection",
    "boosters": "Boosters",
    "market": "Marché",
    "social": "Social",
    "more": "Plus",
    "menu": "Ton espace de jeu",
    "openMenu": "Ouvrir toutes les rubriques du jeu",
    "preferences": "Préférences",
    "admin": "Espace staff",
    "animes": "Œuvres",
    "fragments": "Fragments",
    "harvest": "Moisson d’Anima",
    "trades": "Échanges",
    "atlas": "Atlas des joueurs",
    "referral": "Parrainage",
    "groups": {
      "play": "À toi de jouer",
      "collection": "Ton album",
      "market": "Le comptoir",
      "community": "La communauté",
      "account": "Ton compte"
    },
    "purge": "Purge",
    "quests": "Succès",
    "calendar": "Calendrier",
    "friends": "Amis",
    "messages": "Messages",
    "profile": "Profil",
    "premium": "Premium",
    "rules": "Règles du jeu",
    "primary": "Navigation principale",
    "skip": "Aller au contenu",
    "discord": "Discord officiel",
    "level": "Niveau {{level}}",
    "levelShort": "Nv. {{level}}",
    "maxLevel": "Niveau maximum",
    "xp": "Expérience",
    "profileAria": "Profil de {{name}}, niveau {{level}}",
    "anima": "Solde d’Anima, voir mon profil",
    "animaValue": "{{amount}} Anima, voir mon profil",
    "notifications": "Notifications",
    "notificationsUnread": "Notifications, {{count}} non lues",
    "badgeClaim": "à réclamer",
    "badgeUnread": "non lus",
    "badgeTrades": "échanges",
    "badgePending": "en attente"
  },
  "footer": {
    "tagline": "Un album, toute une communauté.",
    "support": "Faire vivre l’aventure",
    "supportNote": "Premium, sans avantage de progression.",
    "explore": "Explorer ANIDEX",
    "community": "La communauté",
    "information": "En toute transparence",
    "home": "Découvrir le jeu",
    "premium": "L’offre Premium",
    "friends": "Les joueurs",
    "referral": "Inviter ses amis",
    "discord": "Discord officiel",
    "sales": "Conditions de vente Premium",
    "independent": "Projet indépendant. Images et œuvres : droits de leurs titulaires.",
    "label": "Informations",
    "rules": "Règles du jeu",
    "terms": "Conditions d’utilisation",
    "privacy": "Confidentialité",
    "notice": "Mentions légales",
    "cookies": "Cookies",
    "contact": "Nous contacter",
    "copyright": "© {{year}} ANIDEX — Edwyn Lengrand",
    "note": "Le jeu reste gratuit. Premium est facultatif. L’Anima n’est pas de l’argent."
  },
  "auth": {
    "signIn": "Se connecter"
  },
  "states": {
    "loading": "Chargement",
    "loadFailed": "Chargement impossible",
    "retry": "Réessayer",
    "searchRequired": "Choisis ce que tu veux afficher",
    "searchRequiredHint": "Lance une recherche ou sélectionne un filtre pour charger les résultats.",
    "loadSelectionHint": "Charge cette sélection uniquement quand tu en as besoin.",
    "nametagFilter": "Étiquette",
    "nametagAll": "Toutes les étiquettes"
  },
  "actions": {
    "showSelection": "Afficher cette sélection",
    "continue": "Continuer",
    "backHome": "Retour à l’accueil",
    "reload": "Recharger",
    "cancel": "Annuler",
    "close": "Fermer",
    "save": "Enregistrer",
    "confirm": "Confirmer",
    "more": "Afficher plus"
  },
  "pagination": {
    "label": "Pagination",
    "prev": "Précédent",
    "next": "Suivant",
    "page": "Page {{page}}"
  },
  "toasts": {
    "close": "Fermer la notification",
    "achievement": "{{title}} : palier {{tier}} récupéré",
    "animeCompleted": "Œuvre complétée",
    "achievementReady": "Palier de succès atteint !",
    "achievementReadyDetail": "{{title}} · palier {{tier}} à réclamer"
  },
  "turnstile": {
    "label": "Vérification"
  },
  "humanCheck": {
    "title": "Petite vérification",
    "body": "Toutes les 30 minutes, Cloudflare vérifie que c’est bien toi qui joues, et pas un robot. Ça prend quelques secondes, puis ton action reprend toute seule.",
    "checking": "Vérification en cours…"
  },
  "install": {
    "label": "Installer l’app",
    "later": "Plus tard",
    "iosBefore": "Touche",
    "share": "Partager",
    "iosMid": "dans Safari, puis",
    "addHome": "Sur l’écran d’accueil"
  },
  "verify": {
    "banner": "Confirme ton adresse email pour ouvrir des boosters et réclamer tes récompenses. Le lien est dans ta boîte de réception.",
    "sent": "Email envoyé.",
    "resend": "Renvoyer l’email"
  },
  "levelUp": {
    "title": "Niveau {{level}} atteint"
  },
  "notFound": {
    "title": "Page introuvable",
    "intro": "Cette page n’existe pas ou a changé d’adresse."
  },
  "routeError": {
    "title": "Une erreur est survenue",
    "intro": "Recharge la page. Si le problème continue, réessaie dans quelques minutes."
  },
  "rarity": {
    "filter": "Filtrer par rareté",
    "progress": "Progression par rareté",
    "all": "Toutes"
  },
  "theme": {
    "label": "Thème",
    "auto": "Auto",
    "light": "Jour",
    "dark": "Nuit",
    "option": "Thème {{label}}"
  },
  "sound": {
    "on": "Sons activés",
    "off": "Sons coupés",
    "group": "Sons d’interface",
    "enabled": "Activés",
    "muted": "Coupés"
  },
  "rank": {
    "aria": "Rang {{rank}}"
  },
  "unlocks": {
    "equippedSuffix": ", équipé",
    "show": "Afficher les cosmétiques débloqués",
    "hide": "Masquer les cosmétiques",
    "more": "Charger +",
    "kinds": {
      "title": "titre",
      "badge": "badge",
      "frame": "cadre",
      "avatar": "avatar",
      "banner": "bannière"
    },
    "groups": {
      "title": "Titres",
      "badge": "Badges",
      "frame": "Cadres",
      "banner": "Bannières",
      "avatar": "Avatars"
    }
  },
  "rewards": {
    "fragments": "+{{formatted}} fragments",
    "booster_one": "1 Booster {{name}}",
    "booster_other": "{{count}} Boosters {{name}}",
    "character": "Personnage {{rarity}}"
  },
  "time": {
    "daysHours": "{{days}} j {{hours}} h",
    "days_one": "{{count}} j",
    "days_other": "{{count}} j",
    "hours": "{{hours}} h {{minutes}} min",
    "minutes": "{{minutes}} min {{seconds}} s",
    "seconds_one": "{{count}} s",
    "seconds_other": "{{count}} s"
  },
  "meta": {
    "home": {
      "title": "ANIDEX - Collectionne des personnages d’œuvres",
      "description": "Ouvre des boosters, collectionne plus de 180 000 personnages d’œuvres, complète tes séries, améliore tes cartes et échange sur le marché."
    },
    "rules": {
      "title": "Règles du jeu",
      "description": "Comprendre ANIDEX : boosters, raretés, fragments, améliorations, Anima, marché, enchères, échanges et progression."
    },
    "terms": {
      "title": "Conditions d’utilisation",
      "description": "Conditions du jeu gratuit ANIDEX : compte, Anima, un compte par adresse IP, et suppression du compte."
    },
    "privacy": {
      "title": "Politique de confidentialité",
      "description": "Données enregistrées par ANIDEX, téléchargement du fichier JSON, et effacement du compte."
    },
    "notice": {
      "title": "Mentions légales",
      "description": "Éditeur, contact et hébergeur du site ani-dex.app."
    },
    "cookies": {
      "title": "Cookies",
      "description": "Le cookie de session ANIDEX, le stockage local du navigateur, et ce que Cloudflare peut déposer."
    },
    "login": {
      "title": "Connexion",
      "description": "Connecte-toi à ANIDEX pour retrouver ta collection, tes boosters et tes échanges."
    },
    "register": {
      "title": "Inscription",
      "description": "Crée un compte ANIDEX gratuit et commence à collectionner des personnages d’œuvres."
    },
    "verify": {
      "title": "Vérification email",
      "description": "Confirme ton adresse email pour sécuriser ton compte ANIDEX."
    },
    "boosters": {
      "title": "Boosters",
      "description": "Ouvre des boosters Standard, Premium ou Chanceux et tire des personnages selon leur popularité."
    },
    "purge": {
      "title": "Purge",
      "description": "Revends plusieurs cartes d’un coup au système, à un prix fixé sur leur valeur."
    },
    "collection": {
      "title": "Ma collection",
      "description": "Parcours ta collection de cartes, filtre par rareté et améliore tes personnages."
    },
    "animes": {
      "title": "Œuvres",
      "description": "Explore les œuvres du catalogue ANIDEX et suis ta progression de complétion."
    },
    "quests": {
      "title": "Succès",
      "description": "Débloque des succès en collectionnant, en ouvrant des boosters et en progressant."
    },
    "calendar": {
      "title": "Calendrier de connexion",
      "description": "Récompenses quotidiennes de connexion : Anima, fragments, boosters et personnages rares."
    },
    "harvest": {
      "title": "Moisson d’Anima",
      "description": "Cagnotte mensuelle d’Anima, alimentée par les frais du marché et les boosters ouverts. À la fin du mois, elle est partagée selon les boosters ouverts."
    },
    "friends": {
      "title": "Amis",
      "description": "Retrouve tes amis collectionneurs, envoie des demandes et suis leur activité."
    },
    "atlas": {
      "title": "Atlas",
      "description": "Parcours les collections visibles de tes amis, carte par carte."
    },
    "messages": {
      "title": "Messages",
      "description": "Messagerie ANIDEX entre collectionneurs."
    },
    "notifications": {
      "title": "Notifications",
      "description": "Tes alertes marché, échanges, amis et progression."
    },
    "profile": {
      "title": "Mon profil",
      "description": "Réglages du profil collectionneur ANIDEX."
    },
    "market": {
      "title": "Marché des cartes",
      "description": "Achète et vends des cartes au prix fixe sur le marché ANIDEX."
    },
    "auctions": {
      "title": "Enchères",
      "description": "Enchéris sur des cartes avec anti-snipe et achat immédiat."
    },
    "myListings": {
      "title": "Mes ventes",
      "description": "Gère tes ventes en cours."
    },
    "myAuctions": {
      "title": "Mes enchères",
      "description": "Les cartes que tu as mises aux enchères."
    },
    "history": {
      "title": "Historique du marché",
      "description": "Historique de tes achats et ventes sur le marché ANIDEX."
    },
    "trades": {
      "title": "Échanges",
      "description": "Propose et accepte des échanges de cartes entre joueurs."
    },
    "notFound": {
      "title": "Page introuvable",
      "description": "Cette page ANIDEX est introuvable ou n’est plus disponible."
    },
    "referral": {
      "title": "Parrainage",
      "description": "Invite tes amis avec ton code de parrainage : ils reçoivent un boost de départ."
    }
  }
}
